export default __webpack_public_path__ + "static/media/campton_bold.5b69b512.ttf";